module.exports = __webpack_public_path__ + "img/yeosu_gallery1.1b139115.jpg";